import { DEFAULT_DATE_FORMAT_TIMEZONE, DEFAULT_DATE_TIMEZONE } from 'common';
import moment from 'moment-timezone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import React from 'react';

const createdDate = (val='') => {
  const dt = moment.tz(val, moment.ISO_8601, DEFAULT_DATE_TIMEZONE);
  if (!dt.isValid()){
    return val;
  }
  return dt.format(DEFAULT_DATE_FORMAT_TIMEZONE);
};

const icon = (val = '') => {
  let element = '';
  if (val === 'TransferApproved') {
    element = (
      <React.Fragment>
        <FontAwesomeIcon icon={faCheckCircle} color="#188138" />
      </React.Fragment>
    );
  } else if (val === 'TransferRejected') {
    element = (
      <React.Fragment>
        <FontAwesomeIcon icon={faTimesCircle} color="#F91616" />
      </React.Fragment>
    );
  }
  return element;
};

export default {
  createdDate,
  icon,
};



// WEBPACK FOOTER //
// ./src/components/AuditTrailPanel/formatters.js